module.exports = __webpack_public_path__ + "static/img/zfs.9fb341f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/zfs.jpg
// module id = xZwC
// module chunks = 0